import { Banner, Button } from '@kanda-libs/ks-design-library';
import { URLS } from 'config';
import { Link } from 'react-router-dom';
import useFinanceEverywhereBanner from './useFinanceEverywhereBanner';

const FinanceEverywhereBanner: React.FunctionComponent = function () {
  const { title, buttonText } = useFinanceEverywhereBanner();
  return (
    <div className="w-full mb-6 md:mb-10 md:-mt-8">
      <Banner>
        <div className="flex w-full flex-col">
          <p className="text-14-22-em md:text-18-22-em text-neutral-900 mb-3">
            {title}
          </p>
          <Link to={URLS.financeEverywhereLink} className="ml-auto">
            <Button.Text
              id="get-finance-everywhere-link"
              label={buttonText}
              size={40}
              icon="plus"
              left
            />
          </Link>
        </div>
      </Banner>
    </div>
  );
};

export default FinanceEverywhereBanner;
